import Divider from './Divider';

const TableOfContentsLeftNav = ({ title, tocHeaders }: { title: string; tocHeaders: string[] }) => {
  return (
    /* This top qty assumes all of our navbars are 70px tall, which is true as of Oct 2025 */
    <div className='hidden sm:block bg-gray-100 max-w-[240px] w-[240px] -ml-2'>
      {/* This is a dummy background-colored panel to fill in the transparent bkg of the header
       * items below. This left panel has to be fixed position but with a height sized relative to the
       * page scroll area, while also contending with the z-index placed gigantic background image
       * from ContentfulLandingPageHeader. The outer div above handles the scroll container - relative
       * height, while this div fills in the area that would be left transparenty by the landing page
       * header image rendering above that outer div. */}
      <div className='relative w-[240px] h-screen bg-gray-100 z-10' />
      <div className='fixed top-[70px] w-[240px] h-screen p-3 z-10'>
        <h5 className='mt-3 mtb-2 font-header text-base leading-6 font-semibold'>{title}</h5>
        <Divider className='!w-18 mt-2' />
        <div className='flex flex-col gap-2 text-sm'>
          {tocHeaders.map((header) => (
            <div>
              <a
                className='hover:underline hover:text-brand-500'
                href={
                  // Ensure window exists before use to avoid crashing the Vite build for static pages
                  typeof window !== 'undefined' ?
                    `${window.location.pathname}#${header.replaceAll(' ', '_')}`
                  : ''
                }
              >
                {header}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableOfContentsLeftNav;
